// MUI
import { Stack } from "@mui/material";

// Types
import { AuthRoleStatus } from "@Settings/types/administrationTools/utils";

type LoggedRolesProps = Readonly<{
	selectedProvider: {
		authRoleStatuses: AuthRoleStatus[];
	} | null;
}>;
export default function LoggedRoles(props: LoggedRolesProps) {
	if (!props.selectedProvider?.authRoleStatuses?.length) {
		return null;
	}

	return (
		<>
			<span></span>
			{props.selectedProvider?.authRoleStatuses?.map((providerSelected) => {
				return (
					<Stack
						key={providerSelected.role}
						mt={0.5}
						className="text-left"
						display={providerSelected.isLoggedIn ? "block" : "none"}
					>
						<span className="font-sans font-normal text-[#666666] text-xs">{`${providerSelected.role} Logged in ${
							providerSelected.username ? `as ${providerSelected.username}` : ""
						} `}</span>
					</Stack>
				);
			})}
		</>
	);
}
